<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="4" >
						<el-form-item label="业务类型" :label-width="'70px'">
							<el-select style="width:130px" v-model="type1" @change="changeType" size="small">
								<el-option
								v-for="item in typeObjArr"
								:key="item.id"
								:label="item.name"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="文件状态" :label-width="'100px'">
							<el-select style="width:130px" v-model="type2" @change="changeType" size="small">
								<el-option
								v-for="item in [{value:0,label:'全部'},{value:1,label:'待签署'},{value:2,label:'已签署'},{value:3,label:'已失效'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8" :offset="5">
						<el-form-item label="时间" :label-width="'60px'">
							<el-radio-group v-model="time1" size="mini" @change="changeTime1">
									<el-radio-button :label="1">近7天</el-radio-button>
									<el-radio-button :label="2">近30天</el-radio-button>
									<el-radio-button :label="3">本月</el-radio-button>
									<el-radio-button :label="4">本季度</el-radio-button>
									<el-radio-button :label="5">本年</el-radio-button>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="3" >
						<el-form-item label="" :label-width="'0px'">
							<el-date-picker v-model="time2" type="month" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" style="width:150px;" @change="changeTime2" placeholder="选择月份">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="chartBox">
			<div class="title">
				<div class="titleL">
					签约文件统计
					<span style="color:#FF182A;" v-if="time1===1">( 近7天 )</span>
					<span style="color:#FF182A;" v-if="time1===2">( 近30天 )</span>
					<span style="color:#FF182A;" v-if="time1===3">( 本月 )</span>
					<span style="color:#FF182A;" v-if="time1===4">( 本季度 )</span>
					<span style="color:#FF182A;" v-if="time1===5">( 本年 )</span>
					<span style="color:#FF182A;" v-if="time1===6">
						( {{$public.FTime(new Date(time2).getTime(),'YYYY-MM')}} )
					</span>
				</div>
				<div class="titleR">
				</div>
			</div>
			<div id="chartItem" style="width: 100%;height: 400px;" @mousedown="mousedown"></div>
		</div>
		<div class="tableBox">
			<div class="title">
				<div class="titleL">
					<span style="color:#FF182A;" v-if="lineData.length>0">{{curDot.name}}</span>
					签署的文件
				</div>
			</div>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="序号" width="50">
					<template slot-scope="props">
						{{parseInt(props.$index+1)}}
					</template>
				</el-table-column>
				<el-table-column label="文件编号" prop="contractNum" >
				</el-table-column>
				<el-table-column label="业务类型" prop="medicalServiceName" >
					<template slot-scope="props">
						{{$types.get_fileTemplate_type(props.row.contractType)}}
					</template>
				</el-table-column>
				<el-table-column label="顾客" prop="memberName" >
				</el-table-column>
				<el-table-column label="手机号" prop="memberMobile" >
				</el-table-column>
				<el-table-column label="宠物" prop="petName" >
				</el-table-column>
				<el-table-column label="签署状态" prop="birthDay" >
					<template slot-scope="props">
						<span v-if="props.row.state===2">已失效</span>
						<span v-if="props.row.state===1">
							<span v-if="props.row.signState===1">待签署</span>
							<span v-if="props.row.signState===2">已签署</span>
							<span v-if="props.row.signState===3">已领走</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="typeName" >
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.createTimeStamp,'YYYY-MM-DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="签署时间" >
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.signTime,'YYYY-MM-DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" >
					<template slot-scope="props">
						<el-button type="text" size="mini" @click="see(props.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../components/page.vue"
	import echarts from "echarts";
	export default {
		components:{page},
		data(){
			return{
				time1:1,
				time2:'',
				type1:0,
				type2:0,
				typeObjArr:[{id:0,name:'全部'}],
				
				chartItem:null,
				lineData:[],
				
				signState:0,
				state:0,
				tableData:[],
				curDayIndex:0,
				curDot:{},
				page:{
					page:1,
					pageSize:10,
					total:0
				}
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		created(){
			let a = JSON.parse(JSON.stringify(this.$types.fileTemplate_type));
			this.typeObjArr = this.typeObjArr.concat(a);
		},
		mounted(){
			this.chartItem = echarts.init(document.getElementById("chartItem"));
			this.getLine();
		},
		methods: {
			// 改变时间
			changeTime1(){
				this.time2='';
				this.getLine()
			},
			changeTime2(){
				if(this.time2===null){
					this.time1 = 1;
				}else{
					this.time1 = 6;
				}
				this.getLine()
			},
			changeType(){
				if(this.type2===0){
					this.signState = 0;
					this.state = 0;
				}else if(this.type2===1){
					this.signState = 1;
					this.state = 1;
				}else if(this.type2===2){
					this.signState = 2;
					this.state = 1;
				}else if(this.type2===3){
					this.signState = 0;
					this.state = 2;
				}
				this.getLine()
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData(this.curDot);
			},
			getTableData(curDot){
				let loading=this.$loading();
				let params = {
					"signState": this.signState,
					"state":this.state,      
					"contractType": this.type1,  // 业务类型
					"searchDate":curDot.stamp,
					type:this.time1===5?2:1,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": ""
				}
				this.$http.post('/api/Contract/Statistics/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 查看
			see(row){
				let loading = this.$loading();
				this.$http.get('/api/Contract/Order/Detail', {contractNum:row.contractNum}).then(res => {
					loading.close()
					if (res.code == 0) {
						window.open(res.data.signContractPdfUrl)
					}
				})
			},
			// 获取折线数据
			getLine(){
				let params = {
					"signState": this.signState, 
					"state":this.state,      
					"contractType": this.type1,  // 业务类型
					"dateType": this.time1,      // 日期类型：1近七天；2近30天；3本月；4本季；5本年；6自定义
					"searchDate": this.$public.FTimeStr10(this.time2),  // 自定义月份
				}
				let loading=this.$loading();
				this.$http.post('/api/Contract/Statistics/Line', params).then(res => {
					loading.close()
					if (res.code == 0) {
						let xArr = [];
						let yArr = [];
						let objArr = res.data;
						for(let i=0;i<objArr.length;i++){
							xArr.push(objArr[i].name);
							yArr.push(objArr[i].value);
						}
						this.draw(xArr,yArr)
						
						this.lineData = res.data;
						this.curDot = this.lineData[0]
						this.page.page = 1;
						this.getTableData(this.curDot);
					}
				})
			},
			mousedown(){
				this.curDot = this.lineData[this.curDayIndex];
				this.getTableData(this.curDot);
			},
			draw(xArr,yArr){
				let option = {
					color: ['#F5882A'],
					grid: {
						left: '3%',
						right: '4%',
						bottom: '50',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						},
						formatter:(params)=>{
							this.curDayIndex = params[0].dataIndex;
							return params[0].axisValueLabel+'：'+params[0].value+' (份) '
						}
					},
					dataZoom: [{
						type: 'slider'
					}],
					xAxis: {
						type: 'category',
						data: xArr,
						axisTick: {
							alignWithLabel: true,
						}
					},
					yAxis: {
						type: 'value',
						name: '数量(份)',
						axisTick: {
						}
					},
					series: [
						{
							data: yArr,
							type: 'line',
							symbol: 'circle',
						},
					]
				};
				this.chartItem.setOption(option);
			}
		}
	}
</script>
<style scoped lang="scss">
.page{
	.searchBox {
		.el-form-item {
			margin-bottom: 0;
		}
	}
	.searchLine{
		height: 60px;background-color: #fff;margin-bottom:10px;display: flex;justify-content: space-between;
		.tabBox{
			display: flex;
			.tabItem{
				font-size: 16px;color:#909399;border-bottom: 3px solid transparent;padding:20px 0px 17px;margin:0 25px;cursor: pointer;
				&.active{
					border-color:#1890FF;color:#2A2A2A;font-weight: bold;
				}
			}
		}
		.searchBox{
			padding:17px 25px 0 0;height: 60px;
			.searchLabel{
				color:#2A2A2A;font-size: 16px;margin:0 5px 0 20px;
			}
			.searchValue{
				
			}
		}
	}
	.chartBox{
		background-color: #fff;margin-top:12px;padding-bottom:10px;
		.title{
			display: flex;justify-content: space-between;padding:14px;
			.titleL{
				font-size: 14px;color:#2A2A2A;
			}
			.titleR{
				.titleLabel{
					font-size: 14px;color:#2A2A2A;margin:0 5px 0 20px;vertical-align: text-bottom;
				}
				.titleValue{
					
				}
			}
		}
	}
	.tableBox{
		background-color: #fff;margin-top:12px;
		.title{
			padding:14px;
		}
	}
}
</style>
